<template>
	<el-form-item label="文案位置">
		<el-radio-group v-model="data.options.position">
			<el-radio-button value="left">左侧</el-radio-button>
			<el-radio-button value="center">居中</el-radio-button>
			<el-radio-button value="right">右侧</el-radio-button>
		</el-radio-group>
	</el-form-item>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
	name: 'ItemDivider',
	props: {
		active: {
			type: Object,
			default: null
		}
	},
	emits: ['update:active'],
	setup(props, context) {
		const data = ref(props.active)
		watch(data, val => context.emit('update:active', val), { deep: true })

		return {
			data
		}
	}
})
</script>
